import { Select } from "antd";
import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";

const DurationPicker = ({ value, onChange, maxDuration = 1, style = {} }) => {
  const [durationList, setDurationList] = useState([]);
  const { t } = useTranslation();

  useEffect(() => {
    const list = [];
    for (let i = 1; i <= maxDuration; i++) {
      list.push({
        value: i,
        label: `${i} ${i > 1 ? t("days") : t("day")}`,
      });
    }
    setDurationList(list);
  }, []);

  useEffect(() => {
    console.log("value", value);
  }, [value]);

  return (
    <div className="duration-picker" style={style}>
      <Select
        style={style}
        options={durationList}
        value={value}
        onChange={e => {
          onChange(e);
        }}
      />
    </div>
  );
};

export default DurationPicker;
